import styled from '@emotion/styled';
import { color } from 'components/core/theme';
import { mediaDesktop } from 'components/core/theme/breakpoints';

interface Props {
  active?: boolean;
}

export const RadioButton = styled.a<Props>`
  flex-grow: 1;
  text-align: center;
  font-weight: 700;
  display: block;
  background-color: white;
  border-top: 2px solid ${color('greyDark')};
  border-bottom: 2px solid ${color('greyDark')};
  color: ${color('greyDark')};
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;

  ${mediaDesktop} {
    &:not(:focus):hover {
      background-color: ${color('yellowLight')};
    }
    :focus {
      background-color: ${color('yellowMedium')};
    }
  }

  :first-of-type {
    border-left: 2px solid ${color('greyDark')};
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }

  :last-of-type {
    border-right: 2px solid ${color('greyDark')};
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
  }
`;
